var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { defaultUnderlineStyle, getStyledLink } from "./CustomLink.constants";
const CustomLink = (_a) => {
    var { title, href, handleClick, isUnderline = false, customStyle } = _a, muiProps = __rest(_a, ["title", "href", "handleClick", "isUnderline", "customStyle"]);
    const theme = useTheme();
    const underlineValue = isUnderline ? defaultUnderlineStyle : {};
    return (_jsx(Link, Object.assign({ href: href, onClick: handleClick, style: Object.assign(Object.assign(Object.assign({}, getStyledLink(theme)), underlineValue), customStyle) }, muiProps, { children: title })));
};
export default CustomLink;
